import { buttonShadow } from '../renderers/buttonShadow';
import { lineFont } from '../state';

export function functionButton(
  use:
    | 'fraction'
    | 'quantity'
    | 'absVal'
    | 'power'
    | 'sub'
    | 'root'
    | 'logTrig'
    | 'inequalities',
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  animated = false,
  animatedColor: string,
  animatedColor2: string,
  side: number,
  disabled = false,
  noFill = false
): void {
  const DEFAULT_BUTTON_SIZE = 38;

  const w = side || DEFAULT_BUTTON_SIZE;
  const h = side || DEFAULT_BUTTON_SIZE;
  const r = 8;

  if (!disabled) {
    ctx.save();

    // Shadow settings (thin gray shadow on lower-right)
    buttonShadow(ctx, x, y, w, h, r);

    // "no fill" is actually a fill with white so shadow is covered up inside button
    ctx.fillStyle = animated ? animatedColor : noFill ? 'white' : 'lightgray';
    ctx.lineWidth = 1;
    ctx.strokeStyle = 'lightgray';
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();

    ctx.stroke();

    ctx.fill();

    ctx.restore();
  }

  ctx.save();

  ctx.beginPath();
  ctx.fillStyle = animated ? animatedColor2 : 'gray';

  if (use == 'fraction') {
    ctx.font = (14 * side) / DEFAULT_BUTTON_SIZE + 'px ' + lineFont;
    x += (12 * side) / DEFAULT_BUTTON_SIZE;
    y += (16 * side) / DEFAULT_BUTTON_SIZE;
    ctx.fillText('\u25A2', x, y);

    y += (3 * side) / DEFAULT_BUTTON_SIZE;

    ctx.lineWidth = 2;
    ctx.strokeStyle = ctx.fillStyle;
    ctx.beginPath();
    ctx.moveTo(x - (6 * side) / DEFAULT_BUTTON_SIZE, y);
    ctx.lineTo(x + (20 * side) / DEFAULT_BUTTON_SIZE, y);
    ctx.closePath();
    ctx.stroke();

    y += (14 * side) / DEFAULT_BUTTON_SIZE;
    ctx.fillText('\u25A2', x, y);
  } else if (use == 'quantity') {
    ctx.font = (18 * side) / DEFAULT_BUTTON_SIZE + 'px ' + lineFont;
    x += (10 * side) / DEFAULT_BUTTON_SIZE;
    y += (26 * side) / DEFAULT_BUTTON_SIZE;
    ctx.fillText('\u25A2', x, y);

    ctx.font = (24 * side) / DEFAULT_BUTTON_SIZE + 'px ' + lineFont;
    x -= (8 * side) / DEFAULT_BUTTON_SIZE;
    ctx.fillText('(', x, y);

    x += (25 * side) / DEFAULT_BUTTON_SIZE;
    ctx.fillText(')', x, y);
  } else if (use == 'absVal') {
    ctx.font = (18 * side) / DEFAULT_BUTTON_SIZE + 'px ' + lineFont;
    x += (10 * side) / DEFAULT_BUTTON_SIZE;
    y += (26 * side) / DEFAULT_BUTTON_SIZE;
    ctx.fillText('\u25A2', x, y);

    ctx.font = (28 * side) / DEFAULT_BUTTON_SIZE + 'px ' + lineFont;
    x -= (6 * side) / DEFAULT_BUTTON_SIZE;
    y += (1 * side) / DEFAULT_BUTTON_SIZE;
    ctx.fillText('|', x, y);

    x += (23 * side) / DEFAULT_BUTTON_SIZE;
    ctx.fillText('|', x, y);
  } else if (use == 'power') {
    ctx.font = (18 * side) / DEFAULT_BUTTON_SIZE + 'px ' + lineFont;
    x += (4 * side) / DEFAULT_BUTTON_SIZE;
    y += (30 * side) / DEFAULT_BUTTON_SIZE;
    ctx.fillText('\u25A2', x, y);

    ctx.font = (12 * side) / DEFAULT_BUTTON_SIZE + 'px ' + lineFont;
    x += (18.5 * side) / DEFAULT_BUTTON_SIZE;
    y -= (12 * side) / DEFAULT_BUTTON_SIZE;
    ctx.fillText('\u25A2', x, y);
  } else if (use == 'sub') {
    ctx.font = (18 * side) / DEFAULT_BUTTON_SIZE + 'px ' + lineFont;
    x += (4 * side) / DEFAULT_BUTTON_SIZE;
    y += (24 * side) / DEFAULT_BUTTON_SIZE;
    ctx.fillText('\u25A2', x, y);

    ctx.font = (12 * side) / DEFAULT_BUTTON_SIZE + 'px ' + lineFont;
    x += (18.5 * side) / DEFAULT_BUTTON_SIZE;
    y += (6 * side) / DEFAULT_BUTTON_SIZE;
    ctx.fillText('\u25A2', x, y);
  } else if (use == 'root') {
    ctx.font = (16 * side) / DEFAULT_BUTTON_SIZE + 'px ' + lineFont;
    x += (17 * side) / DEFAULT_BUTTON_SIZE;
    y += (27 * side) / DEFAULT_BUTTON_SIZE;
    ctx.fillText('\u25A2', x, y);

    ctx.font = (10 * side) / DEFAULT_BUTTON_SIZE + 'px ' + lineFont;
    x -= (15 * side) / DEFAULT_BUTTON_SIZE;
    y -= (7 * side) / DEFAULT_BUTTON_SIZE;
    ctx.fillText('\u25A2', x, y);

    ctx.lineWidth = 2;
    ctx.strokeStyle = ctx.fillStyle;
    y += (3 * side) / DEFAULT_BUTTON_SIZE;
    ctx.moveTo(x, y);
    x += (9 * side) / DEFAULT_BUTTON_SIZE;
    ctx.lineTo(x, y);
    x += (2 * side) / DEFAULT_BUTTON_SIZE;
    y += (4 * side) / DEFAULT_BUTTON_SIZE;
    ctx.lineTo(x, y);
    x += (4 * side) / DEFAULT_BUTTON_SIZE;
    y -= (17 * side) / DEFAULT_BUTTON_SIZE;
    ctx.lineTo(x, y);
    x += (19 * side) / DEFAULT_BUTTON_SIZE;
    ctx.lineTo(x, y);
    ctx.stroke();
  } else if (use == 'logTrig') {
    ctx.font = (14 * side) / DEFAULT_BUTTON_SIZE + 'px ' + lineFont;
    ctx.textBaseline = 'top';
    x += (6 * side) / DEFAULT_BUTTON_SIZE;
    y += (6 * side) / DEFAULT_BUTTON_SIZE;
    ctx.fillText('log /', x, y);
    x += (2 * side) / DEFAULT_BUTTON_SIZE;
    y += (15 * side) / DEFAULT_BUTTON_SIZE;
    ctx.fillText('trig', x, y);
  } else if (use == 'inequalities') {
    ctx.font = (20 * side) / DEFAULT_BUTTON_SIZE + 'px ' + lineFont;
    ctx.textBaseline = 'top';
    x += (4 * side) / DEFAULT_BUTTON_SIZE;
    y += (1 * side) / DEFAULT_BUTTON_SIZE;
    ctx.fillText('<  >', x, y);
    y += (16 * side) / DEFAULT_BUTTON_SIZE;
    ctx.fillText('\u2264  \u2265', x, y);
  }

  ctx.restore();
}
